<script>
  import BodyScroll from 'utils/BodyScroll';

  import {MVue} from 'index';

  export default {
    name: 'MModalMixin',
    data () {
      return {
        modalComponent: null, // MModal component, should be specified in component
        modalProps: {}, // props that are passed to modal
        modalEventListeners: {}, // modal event listeners

        // internal use :D, do not override
        modalNode: null, // modal node
        prevOverflow: null // prev overflow state of <body>
      };
    },
    beforeDestroy () {

      // remove modal if parent component is destroying (f.e. url change)
      this.hidePopup();
    },
    methods: {
      showPopup () {
        const store = this.$store || null;

        this.modalNode = new MVue({
          store,
          render: (h) => h(this.modalComponent, {
            props: this.modalProps,
            on: this.modalEventListeners
          })
        }).$mount();

        document.body.append(this.modalNode.$el);
        BodyScroll.disable();
      },
      hidePopup () {
        if (!this.modalNode) {
          return;
        }
        BodyScroll.enable();

        this.modalNode.$children[0].$children[0].removeModal().then(() => {
          // during double click there may be race condition with 2 promises, do nothing if modal is already deleted

          if (this.modalNode) {
            this.modalNode.$el.remove();
            this.modalNode.$destroy();
            this.modalNode = null;
          }
        });
      }
    }
  };
</script>
